<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-catalogue code="situation" v-model="sasNeuropsy.situation" :live="liveSasNeuropsy(7602)" @eudo-updated="updatePanier"> </opq-catalogue>
    <template v-if="estSituation(1) || estSituation(2)">
      <opq-alert code="situation-parcours-academique"></opq-alert>
    </template>

    <template v-if="estSituation(2)">
      <opq-alert code="situation-approbation-cours"></opq-alert>
    </template>

    <template v-if="estSituation(3)">
      <opq-alert code="situation-dispense-formation"></opq-alert>
      <opq-alert code="situation-fichiers-exp-travail"></opq-alert>
    </template>

    <opq-text-field :opq-if="estSituation(1)" code="diplome" v-model="sasNeuropsy.diplome" :live="liveSasNeuropsy(7603)"></opq-text-field>
    <opq-catalogue :opq-if="estSituation(1)" code="universite-diplome" v-model="sasNeuropsy.universite" :live="liveSasNeuropsy(7604)">
    </opq-catalogue>
    <opq-text-field
      :opq-if="estSituation(1)"
      code="annee-obtention-diplome"
      v-model="sasNeuropsy.anneeDObtention"
      :live="liveSasNeuropsy(7605)"
      is-number
    ></opq-text-field>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import AdressePersonnelle from "@/components/FormParts/AdressePersonnelle"
import CataloguesHelpers from "@/mixins/CataloguesHelpers"
import { mapActions } from "vuex"

export default {
  mixins: [FormSimple, CataloguesHelpers],
  components: { AdressePersonnelle },
  props: {
    sas: { type: Object }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasNeuropsy(cle) {
      return { endpoint: "sas-neuropsy", cle: cle, fileId: this.sasNeuropsy.id }
    },
    estSituation(codeSituation) {
      return this.getCatalogueCodeById(7808, this.sas.sasNeuropsy.situation) == codeSituation
    },
    async updatePanier() {
      await this.fetchPanier(this.sas.id)
    }
  },

  computed: {
    sasNeuropsy() {
      return this.sas.sasNeuropsy
    }
  }
}
</script>